// 定义中文语言包对象
export default {
  headContent: {
    title: '箭弩学术',
    subTitle: '学术期刊大数据'
  },
  navigateBar: {
    home: '首页',
    productService: '产品&服务',
    openData: '开放数据',
    blog: '博客',
    contactUs: '联系我们',
    ojsSupport: 'OJS技术支持',
    updatedJournalLists: '每月期刊数据更新',
    dynamicJournalImpactFactor: '实时影响因子',
    impactFactorManagment: '影响因子管理',
    journalEvaluationManagement: '期刊的评估与管理',
    qualifiedAuthorTargeting: '目标作者匹配'
  },
  bottomContent: {
    contactEmail: '联系邮箱：',
    backContent: '为您提供专业的国际化期刊创建及运营一站式服务',
  },

  index: {
    first: {
      title: '科技期刊申请Scopus SCI 检索<br /><span>申前评估</span>',
      contactBtn: '联系我们'
    },
    second: {
      title: '期刊影响力提升工具',
      leftTitle: 'AI工具',
      rightTitle: 'TrendMD插件',
      leftContent1: '实时引用追踪呈现',
      leftContent2:'算法驱动精准推荐相关论文',
      leftContent3:'丰富深入的期刊分析数据',
      leftContent4:'千万篇优质学术文章的联结窗口',
      rightContent: 'TrendMD是较早开展学术论文算法动态推荐阅读的小工具。每次访问，被推荐的论文动态变化，可以实现论文之间的互联，是由内容驱动的网页小工具。<br>此工具可以实现付费推广阅读，增加论文的曝光量、阅读量。',
      btnText: '申请试用'
    },
    third: {
      title: 'Clarivate期刊收录的金标准：“24+4”准则',
    },
    fourth: {
      title: '行业动态',
      btnText: '查看更多',
      noData: '暂无数据',
      tab1: '收录动态',
      tab2: '检索预评估',
      tab3: '成功案例',
      tab4: '新手指南',
    },
    sixth: {
      title: '开放数据',
      subTitle: '每月期刊数据更新 | 实时影响因子 | on hold期刊和被镇压期刊',
      content1li1: '每月期刊数据更新',
      content1li2: '实时影响因子',
      content1li3: 'on hold期刊和被镇压期刊',
      title2: '开放科学成员'
    },
	seventh:{
		title:'了解有关Contrimetric Plugin的更多信息',
		emptyInfo:'您的浏览器不支持视频标签'
	}

  },

  blog: {
    title: '博客',
    keyWord: '关键词',
    readAll: '阅读全部'
  },
  aboutUs: {
    title: '联系我们',
    reply: '请留下您的信息，我们的工作人员收到邮件后会在1-3个工作日内回复您。',
    contact_info1: '箭弩学术：关注学术期刊出版咨询的专业公众号。',
    contact_info2: '学术期刊大数据服务平台。',
    contact_info3: '咨询服务：办刊指导；学术情报；期刊测评；期刊并购。',
    contact_info4: '技术服务：期刊影响力提升；期刊影响因子管理；',
    contact_info5: '专业服务：ESCI晋升SCI；普刊入选SCI；普刊入选ESCI；普刊入选Scopus。',
    contact_info6: '欢迎国内期刊同行来电、来信聊聊。'
  },
  formAbout: {
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    message: '留言',
    submit: '提交'
  },
  formRules: {
    name: '请输入姓名',
    email: '请输入邮箱',
    emailFormat: '请输入正确的邮箱格式',
    phone: '请输入电话',
    phoneFormat: '请输入正确的电话格式',
    message: '请输入留言',
    phoneEmail:'请输入电话或邮箱',
    phoneEmailFormat: '请输入正确的电话或邮箱格式',
    nameFormat: '联系人姓名长度应在2到20个字符之间',

  },

  jem: {
    title: '期刊的评估与管理',
    subTitle: '期刊质量测评',
    subTitle1: '研究前沿',
    subTitle2: '编辑的评估与管理',
    subTitle3: '合作发展',
    subTitle4: '数据库检索',
    content: '学科热点、学科前沿、新兴科学问题，是无数学者所追求并为之努力的前进方向。若期刊所发表文章的研究主题与当前学术研究热点以及国际前沿领域有所重合，这将能够大大提升期刊的学术影响力，并有助于期刊发展成为国际一流期刊。',
    content1: '编委会和评审人是期刊核心竞争力的重要组成部分，是掌舵期刊办刊方向和学术出版质量的“守门人”。期刊若要获得可持续发展，必须要做好编委会和同行评审的建设工作。对于处在成长期的期刊，为了快速提升提升期刊影响力，有必要建立务实的编委会和评审人，并发挥他们的学术优势与沟通优势来为期刊快速成长奠定基础。',
    content2: '箭弩学术接收所有领域期刊的数据分析和委托。其中许多期刊被Clarivate Web of Science, Scopus, COMPENDEX和PubMed检索，其中一些期刊影响因子很高。',
    firstLi1: '评估期刊文章处理及同行评审流程',
    firstLi2: '了解每篇文章对您期刊整体引文表现的相对贡献',
    secondLi1: '研究成果评估，与同领域期刊进行比较',
    secondLi2: '了解您如何定位热点话题及前沿研究',
    secondLi3: '根据领域内前沿研究和热门话题对期刊的发展方向进行修正',
    thirdLi1: '评估编委会成员的引文网络及如何影响期刊的绩效与发展',
    thirdLi2: '指定编委从个人到集体的定量绩效指标，补充期刊的定性评估标准',
    thirdLi3: '邀请领域内专家学者担任编委会重要角色。',
    thirdLi4: '扩展评审人才库，与审稿人建立牢固的合作关系',
    thirdLi5: '提高同行评审人的知名度和认可度',
    fourthLi1: '为期刊匹配最合适的出版机构',
    fourthLi2: '寻找合适的学术、高校、政府和企业伙伴',
    fourthLi3: '促进跨学科合作并建立友好期刊关系',
    fourthLi4: '寻找战略合作伙伴，提高期刊声誉',
    fifthLi1: '各数据库检索标准分析',
    fifthLi2: '期刊培育管理及咨询',
    fifthLi3: '期刊送检前模拟测评',
    application: '申请试用',
    bottomText: '知名出版商 & 知名大学&协会',
    bottomText1: '知名出版商',
    bottomText2: '知名大学&协会',
  },
  ifm: {
    title: '影响因子管理',
    subTitle: '影响因子是最客观反应期刊质量的标准之一，稳步提升期刊影响因子是期刊晋升SCI/SSCI之后的一项长期任务，为高效、快捷地提升期刊影响因子，箭弩学术为期刊提供影响因子监控与预警服务。',
    subTitle1: '影响因子计算公式：',
    subTitle4: 'IF(2024)=Citation from all DT in 2024/ Number of (A+R)Publication in 2022 & 2023',
    contentTitle1: '引文网络分析',
    contentTitle2: '避免引文陷阱',
    contentTitle3: '提高影响因子及分区',
    contentFirstLi1: '预测实时影响因子',
    contentFirstLi2: '计算引用分布情况，包含地区、国籍和出版机构等',
    contentSecondLi1: '科普引用陷阱：堆叠引用&自引率过高',
    contentThirdli1: '同学科期刊表现力分析报告',
    contentThirdli2: '推广发表论文到海内外科研团队从而转化为有效引用',
  },
  qat: {
    title: "目标作者匹配",
    subTitle: '大数据精准匹配',
    li1: '建立目标群里数据库',
    li2: '个性化定制 征稿邮件/宣传邮件',
    li3: '建立订阅/退订系统',
    li4: '清洗数据库，找到精确目标群体',
    li5: '向数据库推广其感兴趣的邮件内容',
    content: '社交媒体吸引',
    content2: '科学网、微信公众号、视频号、微博等'
  },
  journalLi: {
    title: '每月期刊数据更新',
    year: '年份',
    type: '类别',
    all: '全部',
    exclude: '排除',
    search: '搜索',
    apply: '应用',
    cancel: '取消',
    reset: '重置',
    searchResults: '搜索结果：为您找到相关论文',
    item: '条',
    journalStatus: '期刊状态',
    searchType: '检索类型',
    month: '月份',
    literature: {
      journalName: '期刊名称',
      issn: 'ISSN',
      year: '年份',
    },
    literatureRules: {
      issn: '请输入ISSN',
      year: '请输入年份',
      journalName: '请输入期刊名称',
    },
    choice: '请选择',
    generalSearch: '普通检索',
    advancedSearch: '高级检索',
    defaultPlaceholder: '请输入内容',
    cancelSelect:'请先选择要取消的项',
    excludeSelect:'选择的项已在排除列表中，请先取消排除',
    applySelect:'选择的项已在应用列表中，请先取消应用',

  },
  djif: {
    title: '实时影响因子',
    description: '暂无数据',
  },
  journalDe: {
    issn: 'ISSN:',
    eissn: 'e-ISSN:',
    detail: '详情:',
    brief: '简称:',
    publisher: '出版商:',
    jci: 'JCI:',
    cycle: '周期:',
    impactIndex: '影响指数:',
    country: '国家:',
    yearPulisherCount: '年发文量:',
    chineseRate: '国人占比:',
    subject: '学科:',
    WhetherLibrary: '是否在库:',
    warning: '中科院预警:',
    webSite: '官网:',
    domesticDivision: '国内分区:',
    bigType: '大类:',
    smallType: '小类:',
    hIndex: 'H指数:',
    citeMySelf: '自引率:',
    isOa: '是否OA:',
    citeScore: 'Cite Score:',
    snip: 'SNIP:',
    sjr: 'SJR:',
    scopusSubject: 'Scopus学科:',
    partition: '分区:',
    rank: '排名:',
    percentage: '百分位:',
    echartTitle: '5年影响指数趋势图',


  },

  applyForm: {
    title: "提交申请",
    journalName: "期刊名称",
    issn: "ISSN",
    webSite: "期刊网址",
    contact: "联系人",
    contactInformation: "电话/邮箱",
    request: "您的需求",
  },


  form: {
    printBtn: '打 印',
    mockBtn: '模 拟',
    submitBtn: '提 交',
    emptyBtn: '清 空',

  },

  paginationText: {
    firstText: '首页',
    lastText: '尾页',
    prevText: '上一页',
    nextText: '下一页'
  },
  messagePrompt: {
    success: '操作成功',
    fail: '操作失败',
    error: '系统错误',
    warning: '操作警告',
    confirm: '确定',
    cancel: '取消',
    delete: '删除',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    deleteWarning: '删除警告',
    deleteConfirm: '确定删除吗？',
    deleteCancel: '取消删除',
    deleteError: '删除错误',
    noSelect: '请先进行选择',
  },
  reCheck: {
    newsTitle:'新闻',
    newsItemContent:'独一无二的参考文献检查利器问世！通过ReCheck，作者和期刊能够对每篇文章参考文献的准确性、权威性和时效性进行深度检查。这不仅有助于提升发表文章的质量，也能显著提高期刊在学术界的整体影响力和声誉。',
    newsButton:'阅读更多'
  },


}